import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ru from "./locales/RU/common.json";
import en from "./locales/EN/common.json";

export const SUPPORTED_LANGUAGES = ["ru", "en"] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: {
        translation: ru,
      },
      en: {
        translation: en,
      }
    },

    supportedLngs: SUPPORTED_LANGUAGES,
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },

    detection: {
      // Откуда брать язык
      order: ["localStorage", "navigator"],

      // Где сохранять
      caches: ["localStorage"],

      // Ключ localStorage
      lookupLocalStorage: "site_language",
    },
  });

export default i18n;